module.exports = __webpack_public_path__ + "img/android.f89fe78c.png";